<template>
  <div class="form-group" :class="{ 'has-error': errors.has(name) }">
    <label v-if="labelText" :for="inputId" :class="[isHorizontal ? labelColumnsClass : '', 'control-label']">
      {{ labelText }}
    </label>
    <div :class="isHorizontal ? inputColumnsClass : ''">
      <template v-if="isTextarea">
                <textarea
                    :disabled="disabled"
                    :autocomplete="autocomplete"
                    ref="input"
                    :id="inputId"
                    class="form-control"
                    :class="inputClass"
                    :name="name"
                    :placeholder="placeholder"
                    @input="updateValue($event.target.value)"
                    :value="value"
                    v-validate="rules"
                    :data-vv-as="fieldFormattedName"
                ></textarea>
      </template>
      <template v-else>
        <input
            :disabled="disabled"
            :autocomplete="autocomplete"
            ref="input"
            :id="inputId"
            class="form-control"
            :class="inputClass"
            :type="type"
            :name="name"
            :placeholder="placeholder"
            @input="updateValue($event.target.value)"
            :value="value"
            v-validate="rules"
            :data-vv-as="fieldFormattedName"
        />
      </template>
      <span class="form-text text-danger" v-if="errors.has(name)"> {{ errors.first(name) }} </span>
    </div>
  </div>
</template>

<script>
import autosize from 'autosize';
import Bus from '../../../bus';

export default {
  props: {
    autocomplete: {
      default: 'on',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    value: null,
    inputId: String,
    inputClass: [String, Object],
    labelText: String,
    name: String,
    formattedName: String,
    type: {
      type: String,
      required: true,
      validator(value) {
        return (
            [
              'textarea',
              'text',
              'email',
              'number',
              'tel',
              'month',
              'week',
              'date',
              'time',
              'datetime',
              'datetime-local',
              'color',
              'search',
              'url',
              'range',
            ].indexOf(value) > -1
        );
      },
    },
    placeholder: String,
    formType: {
      type: String,
      default: 'vertical',
      validator(value) {
        return ['horizontal', 'vertical'].indexOf(value) > -1;
      },
    },
    columns: {
      type: Number,
      default: 0,
    },
    breakpoint: {
      type: String,
      default: 'sm',
      validator(value) {
        return ['xs', 'sm', 'md', 'lg'].indexOf(value) > -1;
      },
    },
    rules: String,
    trimValue: Boolean,
  },
  data() {
    return {
      totalColumns: 12,
    };
  },
  computed: {
    labelColumnsClass() {
      const columns = this.totalColumns - this.columns;

      return `col-${this.breakpoint}-${columns}`;
    },
    inputColumnsClass() {
      return `col-${this.breakpoint}-${this.columns}`;
    },
    isHorizontal() {
      return this.formType === 'horizontal';
    },
    isVertical() {
      return this.formType === 'vertical';
    },
    isTextarea() {
      return this.type === 'textarea';
    },
    fieldFormattedName() {
      if (this.formattedName) {
        return this.formattedName.toLowerCase();
      }

      return this.name;
    },
  },
  methods: {
    updateValue(value) {
      let formattedValue = value;

      if (this.trimValue) {
        formattedValue = value.trim();
      }

      // If the value was not already normalized,
      // manually override it to conform
      if (formattedValue !== value) {
        this.$refs.input.value = formattedValue;
      }

      this.$emit('input', formattedValue);
    },
    validate() {
      this.$validator
          .validateAll()
          .then(() => {})
          .catch(() => {});
    },
    validateFields(fields) {
      fields.map((field) => {
        this.$validator.validate(field.name, field.model);
      });
    },
    clearValidation() {},
  },
  created() {
    Bus.$on('validate', this.validate);

    Bus.$on('validate-fields', (fields) => {
      this.validateFields(fields);
    })

    Bus.$on('clear-validation', this.clearValidation);

    this.$watch(
        () => this.errors.errors,
        value => {
          Bus.$emit('errors-changed', value);
        }
    );
  },
  mounted() {
    if (this.isTextarea) {
      this.$nextTick(() => {
        autosize(this.$refs.input);
      });
    }
  },
  beforeDestroy() {
    Bus.$off('validate', this.validate);
    Bus.$off('clear-validation', this.clearValidation);
  },
};
</script>